export const defaultSettings = {
  platform: "native",
  theme: "auto",
  layout: "stacked",
  playAs: "infer",
} as const;

export const DEFAULT_SHOW_TRANSCRIPT = true;
export const DEFAULT_SHOW_DOWNLOAD = true;
export const DEFAULT_SHOW_AD = true;
// hiding this for now; product wants to put it behind billing
export const DEFAULT_SHOW_LANGUAGE_DROPDOWN = false;
